"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cache = cache;
exports.sessionCache = sessionCache;
function cache(item) {
    return {
        get: function get() {
            return JSON.parse(localStorage.getItem(item));
        },
        set: function set(data) {
            localStorage.setItem(item, JSON.stringify(data));
        },
        remove: function remove() {
            localStorage.removeItem(item);
        }
    };
}

function sessionCache(item) {
    return {
        get: function get() {
            return JSON.parse(sessionStorage.getItem(item));
        },
        set: function set(data) {
            sessionStorage.setItem(item, JSON.stringify(data));
        },
        remove: function remove() {
            sessionStorage.removeItem(item);
        }
    };
}